/**
 * codeGenerator.ts
 * Generates alphanumeric room slugs in the format: GURO-XXXX
 * e.g. "GURO-4F2A", "GURO-K9MZ"
 */

const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // removed I,O,0,1 to avoid confusion

/**
 * Generates a random 4-character segment.
 */
function randomSegment(length = 4): string {
  let result = '';
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  for (const byte of array) {
    result += CHARS[byte % CHARS.length];
  }
  return result;
}

/**
 * Returns a room code like "GURO-4F2A"
 */
export function generateRoomCode(): string {
  return `GURO-${randomSegment(4)}`;
}

/**
 * Validates that a string matches the GURO-XXXX format.
 */
export function isValidRoomCode(code: string): boolean {
  return /^GURO-[A-Z0-9]{4}$/.test(code.toUpperCase().trim());
}

/**
 * Normalizes user input into canonical room code format.
 */
export function normalizeRoomCode(input: string): string {
  const cleaned = input.toUpperCase().trim().replace(/\s+/g, '');
  // Support user typing "GURO4F2A" without the dash
  if (/^GURO[A-Z0-9]{4}$/.test(cleaned)) {
    return `${cleaned.slice(0, 4)}-${cleaned.slice(4)}`;
  }
  return cleaned;
}
